export default __webpack_public_path__ + "static/media/BOUDRAAOmarCV.b4c96714.pdf";